// @flow
import React from 'react';
import ReactDOM from 'react-dom';

// Size of the icon circle, which is also needed in CoordinateIcon to scale the background image.
export const ADMIN_ICON_SIZE = 68;

type Coordinate = {
  x: number,
  y: number,
};
type Props = {
  picture: string,
  coordinates: Array<Coordinate>,
};
type State = {
  picture: string,
  coordinates: Array<Coordinate>,
};
export default class PictureSearchCMS extends React.PureComponent<Props, State> {
  uploadImg: Image;
  constructor(props: Props): void {
    super(props);
    this.state = {
      picture: this.props.picture,
      coordinates: this.props.coordinates,
    };
    this.uploadImg = new Image();
    if (this.props.picture) {
      this.uploadImg.src = this.props.picture;
    }
  }

  handleUpload = (event: SyntheticInputEvent<EventTarget>): void => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      this.setState(
        prevState => ({
          ...prevState,
          picture: e.target.result,
        }),
        () => {
          this.uploadImg.src = this.state.picture;
        },
      );
    };
    reader.readAsDataURL(file);
  };

  imgClickHandle = (e: SyntheticMouseEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    const rect = img.getBoundingClientRect();
    const tempX = this.uploadImg.width / rect.width;
    const tempY = this.uploadImg.height / rect.height;
    const coor = { x: (e.clientX - rect.left) * tempX, y: (e.clientY - rect.top) * tempY };
    this.setState(prevState => ({
      coordinates: [...prevState.coordinates, coor],
    }));
  };

  removeCoord = (index: number) => () => {
    this.setState(prevState => ({
      coordinates: prevState.coordinates.filter((item, filterIndex) => filterIndex !== index),
    }));
  };

  renderCoordinateList = () => (
    <div className="ps__coor-library">
      {this.state.coordinates.map((val, index) => (
        <div
          onClick={this.removeCoord(index)}
          key={index}
          className="ps__coor-item"
          style={{
            width: `${ADMIN_ICON_SIZE}px`,
            height: `${ADMIN_ICON_SIZE}px`,
            backgroundImage: `url('${this.uploadImg.src}')`,
            backgroundRepeat: 'repeat',
            backgroundPosition: `-${(val.x - (ADMIN_ICON_SIZE / 2)) + this.uploadImg.width}px -${(val.y - (ADMIN_ICON_SIZE / 2)) + this.uploadImg.height}px`,
          }}
        />
      ))}
    </div>
  );

  render(): React$Element<any> {
    return (
      <div className={'u-margin-top'}>
        <label className="form-label" htmlFor="games_picture_search_picture">
          Zoekplaatje
        </label>
        <input
          type="file"
          id="games_picture_search_picture"
          name="games_picture_search[picture]"
          accept="image/png, image/jpeg"
          onChange={this.handleUpload}
          className="form-control"
        />
        <input
          name="games_picture_search[coordinate_list]"
          id="games_picture_search_coordinate_list"
          type="hidden"
          value={JSON.stringify(this.state.coordinates)}
        />
        <p className="help-block">{'Een afbeelding van 16x9 en ongeveer 900px breed.'}</p>
        {this.state.picture && (
          <img
            id="upload_img"
            src={this.state.picture}
            style={{ width: '100%' }}
            onClick={this.imgClickHandle}
            alt="zoekplaatje"
          />
        )}
        {this.renderCoordinateList()}
        {
          this.state.picture &&
            <p>
              Klik op bovenstaande afbeelding om een zoekpunt toe te voegen.
              Onder de afbeelding verschijnt een lijst met zoekpunten.
              Klik op een zoekpunt in de lijst om het punt weer te verwijderen.
            </p>
        }
      </div>
    );
  }
}

const pictureSearchElement = document.querySelector('#picture_search_cms');
if (pictureSearchElement) {
  const data = pictureSearchElement.dataset;
  const props = {
    picture: data.picture,
    coordinates: data.coordinates ? JSON.parse(data.coordinates) : [],
  };
  ReactDOM.render(<PictureSearchCMS {...props} />, pictureSearchElement);
}
